import SectionCard from "./SectionCard";
import DetailRow from "./DetailRow";
import MembersSection from "./MembersSection";
import { sentenceCase } from "./utils";

const EndpointsAccessCard = ({ row, currentUserEmail }) => {
  return (
    <SectionCard title="Endpoints & access">
      <DetailRow
        label="Tenant API"
        value={row?.meta?.tenant_api_endpoint}
        mono
        copyable
      />
      <DetailRow
        label="DevOps admin"
        value={row?.meta?.devops_admin_username}
        mono
        copyable
      />
      <DetailRow label="Owner" value={row?.owner} />
      <DetailRow
        label="Your access"
        value={row?.memberRole ? sentenceCase(row.memberRole) : null}
      />
      <MembersSection row={row} currentUserEmail={currentUserEmail} />
    </SectionCard>
  );
};

export default EndpointsAccessCard;
